import { SortKey } from '@/components/cashflow/transactions/TransactionEntriesTable';
import {
    CashflowTransactionEntry,
    getMerchantName,
} from '@common/react/cashflow';
import { SortDirection } from '@common/react/cashflow/types';
import { sortBy } from '@common/util/arrays';

export const sortTransactionEntries = (
    transactionEntries: CashflowTransactionEntry[],
    sortKey: SortKey,
    direction: SortDirection
) =>
    sortBy(
        transactionEntries,
        (transactionEntry) => {
            switch (sortKey) {
                case SortKey.Account:
                    return transactionEntry.financialEntity.id;
                case SortKey.Date:
                    return (
                        transactionEntry.date +
                        (transactionEntry.isPending ? 'b' : 'a') // Pending transactions should appear before non-pending transactions on the same date
                    );
                case SortKey.Amount:
                    return transactionEntry.amount;
                case SortKey.Category:
                    return transactionEntry.category.name;
                case SortKey.Merchant:
                    return getMerchantName(transactionEntry);
            }
        },
        direction
    );
